import store from '@/store/index.js'

export function showSnackbar(_snackbar) {
    store.dispatch('setAcessoRealtecSnackBar', {
        visible: true,
        message: _snackbar.message,
        color: _snackbar.color
    })
}